<form (ngSubmit)="saveInvoice()" [formGroup]="invoiceForm">
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">
      {{ invoice?.id ? 'Update' : 'Add' }} {{ isRCDSS ? 'Document' : 'Invoice' }}
    </h4>
    <button type="button" class="close" aria-label="Close" (click)="closeModal()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <mat-form-field *ngIf="!isRCDSS">
        <textarea placeholder="Description"
                  rows="6" formControlName="description" matInput></textarea>
    </mat-form-field>

    <div class="my-4">
      <div class="file-row" style="height: unset;" *ngIf="!invoice || invoice.status === 'pending'">
        <div class="add-file text-center">
          <label class="btn btn-link">
              <span class="file-icon">
                <i class="fa fa-paperclip"></i>
              </span>
            <span *ngIf="!files.length">Add file *</span>
            <span *ngIf="files.length">Change file</span>
            <input type="file" (change)="addFile($event)" style="display:none;"/>
          </label>
        </div>
      </div>

      <div class="file-item mb-2" *ngFor="let fileItem of files; let $index = index;">
        <div class="d-flex col-md-12 justify-content-center">
          <div class="document-icon">
            <i class="fa fa-file"></i>
          </div>
          <div class="file-info-container mx-4" *ngIf="!fileItem.file_id">
            {{fileItem.name }} - {{ fileItem.size | fileSize }}
          </div>
          <div class="file-info-container mx-4" *ngIf="fileItem.file_id">
            {{fileItem.file_name }} - {{ fileItem.file_size | fileSize }}
          </div>
          <!--<a class="clickable" *ngIf="!fileItem.file_id">
            <i class="fa fa-close" (click)="removeFile(fileItem, $index)"></i>
          </a>-->
        </div>
      </div>

    </div>

    <div *ngIf="!isRCDSS">
      <h5>Line Items</h5>

      <div class="mb-2" [formGroup]="invoiceLineItemForm">
        <div class="row">
          <div class="col">
            <mat-form-field>
              <mat-select
                placeholder="Select an item"
                formControlName="line_item_id">
                <mat-option
                  [value]="item.id"
                  *ngFor="let item of lineItemsFiltered$ | async">
                  {{ item.product_name }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="col">
            <mat-form-field>
              <input type="number"
                     min="1"
                     placeholder="Quantity Invoiced" matInput formControlName="quantity_invoiced">
            </mat-form-field>
          </div>

          <div class="col-sm-2">
            <button type="button" class="btn btn-primary"
                    [disabled]="invoiceLineItemForm.invalid || (!invoiceLineItemForm.get('line_item_id').value && !invoiceLineItemForm.get('quantity_invoiced').value)"
                    (click)="addInvoiceLineItem()">
              <i class="fa fa-plus"></i>
            </button>
          </div>

        </div>

      </div>


      <div class="mb-2"
           *ngFor="let item of selectedLineItems; let i = index">
        <div class="row">
          <div class="col">
            {{ item.product_name }}
          </div>
          <div class="col">
            {{ item.quantity_invoiced }}
          </div>

          <div class="col-sm-2">
            <a type="button" class="btn btn-link text-danger p-0" (click)="removeInvoiceLineItem(item, i)">
              <i class="fa fa-times"></i>
            </a>
          </div>
        </div>
      </div>
    </div>

  </div>
  <div class="modal-footer">
    <button class="btn btn-primary"
            [disabled]="invoiceForm.invalid || !files.length">Save
    </button>
    <button type="button" class="btn btn-danger" (click)="closeModal()">Cancel</button>
  </div>
</form>
